import { useReducer } from 'react';
type SetPermissionAction = {
  type: 'set_permission';
  payload: {
    id: string;
    value: boolean;
  };
};
type SetPermissionsAction = {
  type: 'set_permissions';
  payload: {
    permissions: PermissionState;
  };
};
type SetAllPermissionsAction = {
  type: 'set_all_permissions';
  payload: {
    permissions: PermissionState;
  };
};
type AcceptAllPermissionsAction = {
  type: 'accept_all_permissions';
};
type RejectAllPermissionsAction = {
  type: 'reject_all_permissions';
};
type PermissionState = Record<string, boolean>;
function permissionReducer(state: PermissionState, action: SetPermissionAction | SetPermissionsAction | SetAllPermissionsAction | AcceptAllPermissionsAction | RejectAllPermissionsAction) {
  switch (action.type) {
    case 'set_permission':
      return {
        ...state,
        [action.payload.id]: action.payload.value
      };
    case 'set_permissions':
      return {
        ...state,
        ...Object.fromEntries(Object.entries(action.payload.permissions).map(([key, value]) => [key, value]))
      };
    case 'set_all_permissions':
      return Object.fromEntries(Object.entries(action.payload.permissions).map(([key, value]) => [key, value]));
    case 'accept_all_permissions':
      return Object.fromEntries(Object.keys(state).map(key => [key, true]));
    case 'reject_all_permissions':
      return Object.fromEntries(Object.keys(state).map(key => [key, false]));
    default:
      return state;
  }
}
export function usePermissionState(initialState: PermissionState) {
  return useReducer(permissionReducer, initialState);
}